export default {
    name: 'states',
    component: () => import(/* webpackChunkName: "states-layout" */ '@/modules/states/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.states.index',
            component: () => import(/* webpackChunkName: "states-index" */ '@/modules/states/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.states.create',
            component: () => import(/* webpackChunkName: "states-create" */ '@/modules/states/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.states.edit',
            component: () => import(/* webpackChunkName: "states-edit" */ '@/modules/states/views/Edit'),
        },
    ]
}